// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-7d99dd5d{to{stroke-dashoffset:0}}.page-disclaimer[data-v-7d99dd5d]{font-size:14px}[data-v-7d99dd5d] ol{list-style-position:outside;padding-left:1rem}[data-v-7d99dd5d] li{padding-left:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
